export default {
  "hierarchy": {
    "rsrcFilterByCreatedAt": [
      "dateTimeRangePicker-rsrcFilterByCreatedAt"
    ]
  },
  "props": {
    "default": {
      "data-error": true,
      "dateFormat": "MM/dd/yyyy",
      "rangeChangeType": null,
      "timeFormat": "hh:mm:ss a"
    },
    "rsrcFilterByCreatedAt": {
      "data-error": true,
      "dateFormat": "MM/dd/yyyy",
      "rangeChangeType": null,
      "timeFormat": "hh:mm:ss a"
    }
  }
}